// extracted by mini-css-extract-plugin
module.exports = {"services":"Services_services__327z1"};